export const categories = [
  {
    id: 'wanghong-tafang',
    name: '网红塌房',
    slug: 'wanghong-tafang',
    description: '网红翻车现场直击，塌房事件第一手爆料，让你看清网红真面目',
    icon: 'ri-user-unfollow-line',
    color: 'primary',
  },
  {
    id: 'mingxing-bagua',
    name: '明星黑料',
    slug: 'mingxing-bagua',
    description: '明星聊天记录泄露、私生活曝光，娱乐圈最劲爆的八卦追踪',
    icon: 'ri-spy-line',
    color: 'accent',
  },
  {
    id: 'fancha-shipin',
    name: '反差视频',
    slug: 'fancha-shipin',
    description: '博主私下真面目大揭秘，台前幕后反差对比视频合集',
    icon: 'ri-contrast-2-line',
    color: 'secondary',
  },
  {
    id: 'liaotian-jilu',
    name: '聊天记录',
    slug: 'liaotian-jilu',
    description: '明星网红聊天记录泄露，真实对话曝光，吃瓜第一视角',
    icon: 'ri-chat-smile-2-line',
    color: 'primary',
  },
  {
    id: 'shipin-bagua',
    name: '视频爆料',
    slug: 'shipin-bagua',
    description: '视频实锤爆料合集，有图有真相，拒绝空口造谣',
    icon: 'ri-video-line',
    color: 'accent',
  },
  {
    id: 'quanzi-redian',
    name: '圈子热点',
    slug: 'quanzi-redian',
    description: '粉丝圈子内部争议、站姐脱粉回踩等实时热点追踪',
    icon: 'ri-fire-line',
    color: 'secondary',
  },
];

export const articles = [
  {
    id: 1,
    title: '某千万粉网红直播带货翻车，当着百万观众面承认虚假宣传',
    slug: 'qianwan-fenhong-wanghong-fanche',
    category: 'wanghong-tafang',
    categoryName: '网红塌房',
    excerpt: '据现场观众爆料，该网红在直播中突然被品牌方当场打脸，场面一度十分尴尬。品牌方工作人员直接上台指出其宣传内容与产品实际参数严重不符...',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20with%20bright%20ring%20lights%20and%20products%20on%20display%2C%20tense%20atmosphere%2C%20warm%20orange%20and%20red%20lighting%2C%20abstract%20artistic%20composition%2C%20cinematic%20mood%2C%20editorial%20photography%20style%2C%20clean%20background%20with%20dramatic%20shadows&width=800&height=500&seq=article-hero-01&orientation=landscape',
    date: '2026-07-06',
    views: 128000,
    comments: 3200,
    isHot: true,
    isFeatured: true,
    content: '',
  },
  {
    id: 2,
    title: '顶流男星前女友深夜发文，万字长文爆料背后惊人内幕',
    slug: 'dingliu-nanxing-qiannvyou-baoliao',
    category: 'mingxing-bagua',
    categoryName: '明星黑料',
    excerpt: '凌晨三点，一篇万字长文在社交媒体引爆热搜。该女星详细披露了与顶流男星恋爱期间的种种细节，包括男方出轨、PUA、以及利用粉丝网暴等行为...',
    image: 'https://readdy.ai/api/search-image?query=Nighttime%20smartphone%20screen%20glowing%20with%20social%20media%20post%20in%20Chinese%2C%20dark%20bedroom%20atmosphere%2C%20moody%20warm%20lighting%2C%20emotional%20storytelling%20mood%2C%20abstract%20cinematic%20composition%2C%20dramatic%20shadows%2C%20editorial%20photography&width=800&height=500&seq=article-hero-02&orientation=landscape',
    date: '2026-07-05',
    views: 256000,
    comments: 8900,
    isHot: true,
    isFeatured: true,
    content: '',
  },
  {
    id: 3,
    title: '知名美妆博主私下竟是这副模样，粉丝直呼滤镜碎了',
    slug: 'meizhuang-bozhu-fancha-shipin',
    category: 'fancha-shipin',
    categoryName: '反差视频',
    excerpt: '一段被曝光的私下聚会视频显示，该博主在镜头外的言行与平时甜美形象形成巨大反差。视频中可以清楚听到其发表的不当言论...',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20contrast%20between%20glamorous%20beauty%20influencer%20on%20camera%20and%20casual%20off-camera%20scene%2C%20warm%20studio%20lighting%20versus%20dim%20party%20atmosphere%2C%20abstract%20artistic%20duality%20concept%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=article-hero-03&orientation=landscape',
    date: '2026-07-04',
    views: 189000,
    comments: 5600,
    isHot: true,
    isFeatured: false,
    content: '',
  },
  {
    id: 4,
    title: '某选秀节目导师私下聊天记录流出，揭露节目组黑幕操作',
    slug: 'xuanxiu-jiemu-heimu',
    category: 'liaotian-jilu',
    categoryName: '聊天记录',
    excerpt: '一份疑似节目组内部聊天记录近日在网上疯传，记录中详细讨论了操纵投票结果、内定出道名单等惊人操作，引发全网热议...',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20Chinese%20chat%20messages%20with%20blurred%20sensitive%20content%2C%20dark%20atmospheric%20background%2C%20warm%20amber%20screen%20glow%2C%20mysterious%20mood%2C%20abstract%20composition%2C%20editorial%20photography%20style%2C%20cinematic%20lighting&width=800&height=500&seq=article-hero-04&orientation=landscape',
    date: '2026-07-03',
    views: 312000,
    comments: 12000,
    isHot: true,
    isFeatured: true,
    content: '',
  },
  {
    id: 5,
    title: '游戏区大主播被爆代打实锤，监控画面清清楚楚',
    slug: 'youxi-zhubo-daidai-shichui',
    category: 'shipin-bagua',
    categoryName: '视频爆料',
    excerpt: '一段监控视频显示，该游戏主播直播间画面中出现的"神操作"，实际上是由其背后的代打完成。视频中两人的配合动作被逐帧分析...',
    image: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20dual%20monitors%20and%20RGB%20lighting%2C%20surveillance%20camera%20style%20composition%2C%20dramatic%20contrast%20between%20bright%20screen%20and%20dark%20room%2C%20tense%20atmosphere%2C%20abstract%20artistic%20interpretation%2C%20clean%20background&width=800&height=500&seq=article-hero-05&orientation=landscape',
    date: '2026-07-02',
    views: 95000,
    comments: 2800,
    isHot: false,
    isFeatured: false,
    content: '',
  },
  {
    id: 6,
    title: '某粉丝站站长脱粉回踩，曝光偶像团队内部混乱管理',
    slug: 'fensi-zhanzhang-tuofen',
    category: 'quanzi-redian',
    categoryName: '圈子热点',
    excerpt: '曾经为该偶像应援花费数十万的站姐，今日突然发布长文宣布脱粉，并曝光了偶像团队内部大量混乱管理细节和财务问题...',
    image: 'https://readdy.ai/api/search-image?query=Fan%20support%20banners%20and%20light%20sticks%20scattered%20on%20the%20ground%2C%20emotional%20farewell%20atmosphere%2C%20warm%20sunset%20lighting%2C%20bittersweet%20mood%2C%20abstract%20composition%2C%20editorial%20photography%20style%2C%20clean%20background&width=800&height=500&seq=article-hero-06&orientation=landscape',
    date: '2026-07-01',
    views: 167000,
    comments: 4500,
    isHot: false,
    isFeatured: false,
    content: '',
  },
  {
    id: 7,
    title: '当红小花深夜密会已婚导演，酒店大堂监控画面曝光',
    slug: 'danghong-xiaohua-mihui-daoyan',
    category: 'mingxing-bagua',
    categoryName: '明星黑料',
    excerpt: '酒店大堂监控拍到两人深夜同框画面，举止亲密。该导演已有家室，且其妻子恰好是圈内知名编剧，事件曝光后引发轩然大波...',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20lobby%20at%20night%20with%20warm%20golden%20lighting%2C%20elegant%20marble%20floors%2C%20dramatic%20shadows%2C%20surveillance%20camera%20perspective%2C%20mysterious%20atmosphere%2C%20abstract%20composition%2C%20editorial%20photography%20style&width=800&height=500&seq=article-hero-07&orientation=landscape',
    date: '2026-06-30',
    views: 423000,
    comments: 15600,
    isHot: true,
    isFeatured: false,
    content: '',
  },
  {
    id: 8,
    title: '百万粉丝穿搭博主被扒全部穿假货，品牌方联合打假',
    slug: 'chuanbo-bozhu-jiahuo',
    category: 'wanghong-tafang',
    categoryName: '网红塌房',
    excerpt: '多家奢侈品牌联合发布声明，指出该博主展示的多件单品均为仿品。更令人震惊的是，该博主还曾以"正品代购"名义向粉丝销售假货...',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20items%20displayed%20on%20clothing%20rack%20with%20magnifying%20glass%20examining%20details%2C%20authenticity%20verification%20concept%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20editorial%20photography%20style%2C%20abstract%20composition&width=800&height=500&seq=article-hero-08&orientation=landscape',
    date: '2026-06-29',
    views: 198000,
    comments: 6700,
    isHot: false,
    isFeatured: false,
    content: '',
  },
  {
    id: 9,
    title: '知名情侣博主突然互删，知情人爆料已分手三个月',
    slug: 'qinglv-bozhu-fenshou',
    category: 'quanzi-redian',
    categoryName: '圈子热点',
    excerpt: '曾经以甜蜜日常吸粉百万的知名情侣博主，近日被网友发现互相取关并删除全部合照。知情人士透露两人实际上已经分手三个月，但为了商业合作一直维持假情侣人设...',
    image: 'https://readdy.ai/api/search-image?query=Two%20smartphones%20lying%20apart%20on%20a%20table%2C%20showing%20empty%20social%20media%20profiles%2C%20emotional%20separation%20concept%2C%20warm%20sunset%20light%20through%20window%2C%20melancholy%20atmosphere%2C%20abstract%20editorial%20composition&width=800&height=500&seq=article-hero-09&orientation=landscape',
    date: '2026-06-28',
    views: 145000,
    comments: 3900,
    isHot: false,
    isFeatured: false,
    content: '',
  },
];

export const comments = [
  {
    id: 1,
    username: '吃瓜小王',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20watermelon%20character%20illustration%20avatar%2C%20simple%20flat%20design%2C%20warm%20colors%2C%20minimal%20style%2C%20circular%20composition%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '天呐这也太劲爆了吧！！！我就说这个网红不对劲，果然翻车了，大快人心！',
    date: '2026-07-06',
    stars: 5,
  },
  {
    id: 2,
    username: '八卦小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Funny%20melon%20slice%20character%20illustration%20avatar%2C%20simple%20flat%20design%2C%20warm%20colors%2C%20minimal%20style%2C%20circular%20composition%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '终于有人爆料这个了！我之前就发现不对劲，但是没人信我，现在真相大白了',
    date: '2026-07-06',
    stars: 5,
  },
  {
    id: 3,
    username: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20night%20owl%20eating%20watermelon%20illustration%20avatar%2C%20simple%20flat%20design%2C%20warm%20colors%2C%20minimal%20style%2C%20circular%20composition%2C%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '我直接好家伙！这瓜保熟吗？有没有更多实锤放出来让大家看看',
    date: '2026-07-05',
    stars: 4,
  },
  {
    id: 4,
    username: '娱乐圈纪检委',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20detective%20watermelon%20illustration%20avatar%2C%20simple%20flat%20design%2C%20warm%20colors%2C%20minimal%20style%2C%20circular%20composition%2C%20clean%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '建议严查！这种欺骗粉丝的行为绝对不能容忍，必须给大众一个交代',
    date: '2026-07-05',
    stars: 5,
  },
  {
    id: 5,
    username: '瓜田里的猹',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20animal%20in%20watermelon%20field%20illustration%20avatar%2C%20simple%20flat%20design%2C%20warm%20colors%2C%20minimal%20style%2C%20circular%20composition%2C%20clean%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '这才是真正的吃瓜！比那些假爆料好看多了，支持继续深挖',
    date: '2026-07-04',
    stars: 4,
  },
  {
    id: 6,
    username: '路人甲不吃瓜',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20watermelon%20with%20sunglasses%20illustration%20avatar%2C%20simple%20flat%20design%2C%20warm%20colors%2C%20minimal%20style%2C%20circular%20composition%2C%20clean%20background&width=80&height=80&seq=avatar-06&orientation=squarish',
    content: '虽然但是，还是要理性吃瓜，不要网暴不要造谣，坐等更多证据',
    date: '2026-07-04',
    stars: 3,
  },
];

export const hotRanking = [
  { rank: 1, title: '顶流男星前女友万字长文爆料', views: '25.6万', slug: 'dingliu-nanxing-qiannvyou-baoliao' },
  { rank: 2, title: '选秀节目组内部聊天记录流出', views: '31.2万', slug: 'xuanxiu-jiemu-heimu' },
  { rank: 3, title: '当红小花深夜密会已婚导演', views: '42.3万', slug: 'danghong-xiaohua-mihui-daoyan' },
  { rank: 4, title: '千万粉网红直播翻车承认虚假宣传', views: '12.8万', slug: 'qianwan-fenhong-wanghong-fanche' },
  { rank: 5, title: '美妆博主私下真面目视频曝光', views: '18.9万', slug: 'meizhuang-bozhu-fancha-shipin' },
  { rank: 6, title: '穿搭博主穿假货遭品牌打假', views: '19.8万', slug: 'chuanbo-bozhu-jiahuo' },
  { rank: 7, title: '粉丝站站长脱粉回踩爆料', views: '16.7万', slug: 'fensi-zhanzhang-tuofen' },
  { rank: 8, title: '情侣博主分手内幕曝光', views: '14.5万', slug: 'qinglv-bozhu-fenshou' },
  { rank: 9, title: '游戏主播代打实锤监控流出', views: '9.5万', slug: 'youxi-zhubo-daidai-shichui' },
  { rank: 10, title: '吃播博主假吃催吐真相揭露', views: '8.2万', slug: 'chuanbo-bozhu-jiahuo' },
];